import { DrawerFields, FieldHeaders, TableFields } from '../../components/table/fieldsConfigTypes';
import Device from '../../models/device';

// Define which fields should be displayed in the table
export const deviceTableFields: TableFields<Device> = [
  undefined, // For the checkbox column
  'label',
  'hostname',
  'serial_number',
  'ip_private',
  'last_heartbeat',
  'app_version',
  'bootloader_version',
  'memory_maximum',
  'cpu_temperature_max',
  'created',
  'command'
];

// Define which fields should appear in the drawer
// with their display names
export const deviceDrawerFields: DrawerFields<Device> = [
  { field: 'model', label: 'Model' },
  { field: 'memory_current', label: 'Current Memory' },
  { field: 'owner', label: 'Owner' },
  { field: 'ip_public', label: 'Public IP' },
  { field: 'mac', label: 'MAC Address' },
  { field: 'os_version', label: 'OS Version' },
  { field: 'cpu_temperature', label: 'CPU Temp' },
  { field: 'subscription_status', label: 'Subscription' }
];

// Header names for table columns
export const deviceFieldHeaders: FieldHeaders = {
  'hostname': 'Hostname',
  'label': 'Label',
  'ip_private': 'Private IP',
  'last_heartbeat': 'Last Heartbeat',
  'app_version': 'App Ver',
  'bootloader_version': 'BL Ver',
  'cpu_temperature_max': 'Max Temp',
  'cpu_temperature': 'CPU Temp',
  'ip_public': 'Public IP',
  'mac': 'MAC Address',
  'created': 'Created',
  'os_version': 'OS Ver',
  'serial_number': 'Serial Number',
  'command_operation': 'Command Status',
  'command': 'Command',
  'model': 'Model',
  'memory_size': 'Memory Size',
  'memory_current': 'Current Memory',
  'memory_maximum': 'Max Mem',
  'owner': 'Owner',
  'subscription_status': 'Subscription'
};